import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities'

class TelegramRepository {

    constructor() {
        this.basePath = store.state.backend;
    }

    associateTelegramUser(telegramData) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/telegram/associate`, telegramData, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }
}

export default new TelegramRepository();
